import { HttpClient } from "../../http/HttpClient";
import CustomerDocumentsRepository from "@/core/customers/repositories/CustomerDocumentsRepository";
import { CustomerDocumentsResponse } from "@/core/customers/entities/CustomerDocuments";
import { ApiResponse } from "../../api/types/ApiResponse";
import { ApiResponseHandler } from "../../http/services/handleApiResponse/handleApiResponse";
import { getDocumentsUrl } from "../../api/documentsEndpoints/documentsEndpoints";
import handleRequestError from "../../http/services/handleRequestError/handleRequestError";
import {
  CustomerDocumentsMapper,
  ApiCustomerDocument,
} from "@/core/customers/mappers/CustomerDocumentsMapper";

export default class CustomerDocumentsRepositoryBackend
  implements CustomerDocumentsRepository
{
  constructor(private readonly httpClient: HttpClient) {}

  async getCustomerDocuments(
    businessKey: string
  ): Promise<CustomerDocumentsResponse> {
    try {
      const url = getDocumentsUrl(businessKey);

      const response = await this.httpClient.get<
        ApiResponse<ApiCustomerDocument[]>
      >({
        url,
        withAuth: true,
      });

      const result = ApiResponseHandler.handleResponse<ApiCustomerDocument[]>(
        response
      );

      if (result.success && result.data) {
        const apiResponse = {
          code: response.code,
          message: response.message,
          data: result.data,
        };

        return CustomerDocumentsMapper.toDomainModel(apiResponse);
      }

      throw ApiResponseHandler.createExceptionFromResponse(response);
    } catch (error) {
      throw handleRequestError(error as ApiResponse<unknown>);
    }
  }
}
